(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function() {
    const cartForm = document.getElementById('CartForm');
    if (!cartForm) return;

    const termsCheckbox = document.getElementById('CartTermsAgree');
    const checkoutBtn = document.getElementById('CartCheckoutBtn');
    const checkoutActions = document.getElementById('CartCheckoutActions');
    const couponInput = document.getElementById('CartCouponInput');
    const couponApply = document.getElementById('CartCouponApply');
    const couponMessage = document.getElementById('CartCouponMessage');
    const noteField = document.getElementById('CartNote');

    function getMoneyFormat() {
      var cartPage = document.getElementById('CartPage');
      if (cartPage && cartPage.dataset.moneyFormat) return cartPage.dataset.moneyFormat;
      if (document.body && document.body.dataset.shopMoneyFormat) return document.body.dataset.shopMoneyFormat;
      return '$' + '{' + '{amount}' + '}';
    }

    function formatMoney(cents) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, getMoneyFormat());
      }
      return (cents / 100).toFixed(2);
    }

    function setPaymentButtonsState(enabled) {
      if (!checkoutActions) return;
      checkoutActions.querySelectorAll(
        '.shopify-payment-button__button, .shopify-payment-button button, [data-shopify="payment-button"]'
      ).forEach(btn => {
        btn.style.pointerEvents = enabled ? '' : 'none';
        btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
        if (!enabled && btn.tagName === 'BUTTON') btn.disabled = true;
        else if (enabled && btn.tagName === 'BUTTON') btn.disabled = false;
      });
    }

    function setCheckoutEnabled(enabled) {
      if (checkoutBtn) checkoutBtn.disabled = !enabled;
      if (checkoutActions) checkoutActions.classList.toggle('is-disabled', !enabled);
      setPaymentButtonsState(enabled);
    }

    termsCheckbox?.addEventListener('change', () => {
      setCheckoutEnabled(termsCheckbox.checked);
    });

    const dynamicCheckout = document.getElementById('CartDynamicCheckout');
    if (dynamicCheckout) {
      const observer = new MutationObserver(() => setPaymentButtonsState(termsCheckbox?.checked));
      observer.observe(dynamicCheckout, { childList: true, subtree: true });
    }

    couponInput?.addEventListener('input', () => {
      if (couponApply) couponApply.disabled = !couponInput.value.trim();
    });

    couponApply?.addEventListener('click', () => {
      const code = couponInput.value.trim();
      if (!code) return;
      window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
    });

    let noteTimer;
    noteField?.addEventListener('input', () => {
      clearTimeout(noteTimer);
      noteTimer = setTimeout(() => {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteField.value })
        });
      }, 600);
    });

    async function changeLine(line, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity })
      });
      if (!res.ok) throw new Error('Cart update failed');
      return res.json();
    }

    function updateTotals(cart) {
      const subtotalEl = document.querySelector('[data-cart-subtotal]');
      const totalEl = document.querySelector('[data-cart-total]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    }

    cartForm.querySelectorAll('[data-qty-control]').forEach(control => {
      const row = control.closest('.cart-page__item');
      const input = control.querySelector('[data-qty-input]');
      const minus = control.querySelector('[data-qty-minus]');
      const plus = control.querySelector('[data-qty-plus]');
      const lineIndex = parseInt(row?.dataset.lineIndex || '0', 10);

      async function setQty(next) {
        const qty = Math.max(0, next);
        input.value = qty;
        row.classList.add('is-updating');
        try {
          const cart = await changeLine(lineIndex, qty);
          if (qty === 0) {
            window.location.reload();
            return;
          }
          const lineItem = cart.items[lineIndex - 1];
          const subtotalCell = row.querySelector('[data-line-subtotal]');
          if (subtotalCell && lineItem) subtotalCell.textContent = formatMoney(lineItem.final_line_price);
          updateTotals(cart);
        } catch (e) {
          window.location.reload();
        } finally {
          row.classList.remove('is-updating');
        }
      }

      minus?.addEventListener('click', () => setQty(parseInt(input.value, 10) - 1));
      plus?.addEventListener('click', () => setQty(parseInt(input.value, 10) + 1));
      input?.addEventListener('change', () => setQty(parseInt(input.value, 10) || 0));
    });

    cartForm.querySelectorAll('[data-remove-line]').forEach(link => {
      link.addEventListener('click', async (e) => {
        e.preventDefault();
        const row = link.closest('.cart-page__item');
        const lineIndex = parseInt(row?.dataset.lineIndex || '0', 10);
        try {
          await changeLine(lineIndex, 0);
          window.location.reload();
        } catch (err) {
          window.location.href = link.href;
        }
      });
    });

    cartForm.addEventListener('submit', (e) => {
      if (e.submitter && e.submitter.name === 'checkout' && !termsCheckbox?.checked) {
        e.preventDefault();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    const ProductsGrid = document.getElementById('ProductsGrid');
    const LoadMoreBtn = document.getElementById('LoadMoreBtn');
    const ShowLessBtn = document.getElementById('ShowLessBtn');
    const FilterMobileBtn = document.getElementById('FilterMobileBtn');
    const SidebarClose = document.getElementById('SidebarClose');
    const CollectionSidebar = document.getElementById('CollectionSidebar');
    const ClearFilters = document.getElementById('ClearFilters');
    const SortBy = document.getElementById('SortBy');
    
    let allProducts = [];
    let displayedProducts = 12;
    const itemsPerLoad = 12;
    const ProductCount = document.getElementById('ProductCount');

    function init() {
      allProducts = Array.from(document.querySelectorAll('.product-card-wrapper')).map(el => ({
        id: el.dataset.productId,
        element: el
      }));

      allProducts.forEach((p, i) => {
        if (i >= displayedProducts) p.element.classList.add('is-hidden');
      });

      if (LoadMoreBtn) LoadMoreBtn.addEventListener('click', loadMore);
      if (ShowLessBtn) ShowLessBtn.addEventListener('click', showLess);
      if (FilterMobileBtn) FilterMobileBtn.addEventListener('click', openSidebar);
      if (SidebarClose) SidebarClose.addEventListener('click', closeSidebar);
      if (ClearFilters) ClearFilters.addEventListener('click', clearAllFilters);
      if (SortBy) SortBy.addEventListener('change', handleSort);

      // Filter events
      document.querySelectorAll('.filter-header').forEach(btn => {
        btn.addEventListener('click', toggleFilterSection);
      });

      document.querySelectorAll('.filter-checkbox').forEach(checkbox => {
        checkbox.addEventListener('change', applyFilters);
      });

      document.querySelectorAll('[data-apply="price"]').forEach(btn => {
        btn.addEventListener('click', applyPriceFilter);
      });

      updateButtonState();
    }

    function toggleFilterSection(e) {
      const filterName = e.currentTarget.dataset.filter;
      const content = document.querySelector(`[data-filter-name="${filterName}"]`);
      const header = e.currentTarget;

      if (content) {
        content.classList.toggle('active');
        header.classList.toggle('active');
      }
    }

    function applyFilters() {
      displayedProducts = 12;
      updateGrid();
    }

    function applyPriceFilter() {
      displayedProducts = 12;
      updateGrid();
    }

    function updateGrid() {
      const filtered = filterProducts(allProducts);

      allProducts.forEach(p => p.element.classList.add('is-hidden'));
      filtered.slice(0, displayedProducts).forEach(p => {
        p.element.classList.remove('is-hidden');
      });

      if (ProductCount) {
        ProductCount.textContent = `Showing ${filtered.length} product${filtered.length === 1 ? '' : 's'}`;
      }

      updateButtonState(filtered.length);
    }

    function filterProducts(products) {
      const availability = Array.from(document.querySelectorAll('input[name="availability"]:checked')).map(cb => cb.value);
      const vendors = Array.from(document.querySelectorAll('input[name="vendor"]:checked')).map(cb => cb.value);
      const weights = Array.from(document.querySelectorAll('input[name="weight"]:checked')).map(cb => cb.value);
      const minPrice = parseFloat(document.getElementById('PriceMin')?.value) || 0;
      const maxPrice = parseFloat(document.getElementById('PriceMax')?.value) || Infinity;

      return products.filter(p => {
        const el = p.element;
        const isAvailable = el.dataset.available === 'true';
        const vendor = el.dataset.vendor || '';
        const price = parseFloat(el.dataset.price || '0') / 100;
        const tags = (el.dataset.tags || '').toLowerCase();

        if (availability.length === 1) {
          if (availability.includes('in-stock') && !isAvailable) return false;
          if (availability.includes('out-of-stock') && isAvailable) return false;
        }
        if (vendors.length && !vendors.includes(vendor)) return false;
        if (weights.length && !weights.some(w => tags.includes(w.toLowerCase()))) return false;
        if (price < minPrice || price > maxPrice) return false;
        return true;
      });
    }

    function loadMore() {
      displayedProducts += itemsPerLoad;
      LoadMoreBtn.classList.add('loading');
      
      setTimeout(() => {
        updateGrid();
        LoadMoreBtn.classList.remove('loading');
      }, 300);
    }

    function showLess() {
      displayedProducts = 12;
      updateGrid();
      ProductsGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function updateButtonState(totalOverride) {
      const total = totalOverride ?? filterProducts(allProducts).length;

      if (LoadMoreBtn) {
        LoadMoreBtn.classList.toggle('hidden', displayedProducts >= total);
      }

      if (ShowLessBtn) {
        ShowLessBtn.classList.toggle('hidden', displayedProducts <= 12);
      }
    }

    function openSidebar() {
      CollectionSidebar.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeSidebar() {
      CollectionSidebar.classList.remove('active');
      document.body.style.overflow = '';
    }

    function clearAllFilters() {
      document.querySelectorAll('.filter-checkbox:checked').forEach(cb => {
        cb.checked = false;
      });
      const priceMin = document.getElementById('PriceMin');
      const priceMax = document.getElementById('PriceMax');
      if (priceMin) priceMin.value = '';
      if (priceMax) priceMax.value = '';
      displayedProducts = 12;
      updateGrid();
    }

    function handleSort(e) {
      const sortValue = e.target.value;
      const grid = ProductsGrid;
      const items = Array.from(grid.querySelectorAll('.product-card-wrapper'));

      items.sort((a, b) => {
        const priceA = parseFloat(a.dataset.price || '0');
        const priceB = parseFloat(b.dataset.price || '0');
        const createdA = parseInt(a.dataset.created || '0', 10);
        const createdB = parseInt(b.dataset.created || '0', 10);

        if (sortValue === 'price-low') return priceA - priceB;
        if (sortValue === 'price-high') return priceB - priceA;
        if (sortValue === 'newest') return createdB - createdA;
        return 0;
      });

      items.forEach(item => grid.appendChild(item));
      allProducts = items.map(el => ({ id: el.dataset.productId, element: el }));
      updateGrid();
    }

    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initTabs(section) {
      var tabs = section.querySelectorAll('.pw-product-tabs__tab');
      var panels = section.querySelectorAll('.pw-product-tabs__panel');
      var accordionTriggers = section.querySelectorAll('.pw-product-tabs__accordion-trigger');

      function activate(panelId) {
        tabs.forEach(function (item) {
          var isActive = item.getAttribute('aria-controls') === panelId;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.id === panelId;
          var trigger = panel.querySelector('.pw-product-tabs__accordion-trigger');

          panel.classList.toggle('is-active', isActive);
          if (trigger) trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.getAttribute('aria-controls'));
        });
      });

      accordionTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var panel = trigger.closest('.pw-product-tabs__panel');
          if (panel) activate(panel.id);
        });
      });
    }

    function boot() {
      document.querySelectorAll('.pw-product-tabs').forEach(initTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initProduct(section) {
      if (!section) return;

      var variantScript = section.querySelector('[data-product-variants]');
      var variants = [];

      if (variantScript) {
        try {
          variants = JSON.parse(variantScript.textContent || '[]');
        } catch (error) {
          variants = [];
        }
      }

      var thumbs = section.querySelectorAll('.pw-product-gallery__thumb');
      var thumbsScroller = section.querySelector('.pw-product-gallery__thumbs');
      var galleryStage = section.querySelector('[data-gallery-stage]');
      var galleryTrack = section.querySelector('[data-gallery-track]');
      var currentMediaIndex = 0;
      var variantInput = section.querySelector('[data-variant-id]');
      var priceEl = section.querySelector('[data-product-price]');
      var compareEl = section.querySelector('[data-compare-price]');
      var skuRow = section.querySelector('[data-sku-row]');
      var skuEl = section.querySelector('[data-product-sku]');
      var stockStatus = section.querySelector('[data-stock-status]');
      var stockText = section.querySelector('[data-stock-text]');
      var addButton = section.querySelector('[name="add"]');
      var addLabel = section.querySelector('[data-add-label]');
      var dynamicCheckout = section.querySelector('[data-dynamic-checkout]');
      var quantityInput = section.querySelector('[data-quantity-input]');
      var addText = section.dataset.addToCartText || 'Add to cart';
      var soldOutText = section.dataset.soldOutText || 'Sold out';
      var inStockText = section.dataset.inStockText || 'In stock and ready to ship';

      function goToMediaIndex(nextIndex) {
        if (!thumbs.length) return;

        currentMediaIndex = nextIndex;
        if (currentMediaIndex < 0) currentMediaIndex = thumbs.length - 1;
        if (currentMediaIndex >= thumbs.length) currentMediaIndex = 0;

        if (galleryTrack) {
          galleryTrack.style.transform = 'translateX(-' + (currentMediaIndex * 100) + '%)';
        }

        thumbs.forEach(function (thumb, index) {
          var isActive = index === currentMediaIndex;
          thumb.classList.toggle('is-active', isActive);
          thumb.setAttribute('aria-current', isActive ? 'true' : 'false');

          if (isActive) {
            thumb.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
              inline: 'nearest'
            });
          }
        });
      }

      function switchMedia(mediaId) {
        if (!mediaId) return;
        var index = Array.from(thumbs).findIndex(function (thumb) {
          return thumb.dataset.mediaId === String(mediaId);
        });
        if (index >= 0) goToMediaIndex(index);
      }

      function stepMedia(direction) {
        goToMediaIndex(currentMediaIndex + direction);
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          goToMediaIndex(index);
        });
      });

      section.querySelector('[data-stage-prev]')?.addEventListener('click', function () {
        stepMedia(-1);
      });

      section.querySelector('[data-stage-next]')?.addEventListener('click', function () {
        stepMedia(1);
      });

      section.querySelector('[data-thumb-prev]')?.addEventListener('click', function () {
        stepMedia(-1);
      });

      section.querySelector('[data-thumb-next]')?.addEventListener('click', function () {
        stepMedia(1);
      });

      if (galleryStage && thumbs.length > 1) {
        var touchStartX = 0;
        var touchStartY = 0;

        galleryStage.addEventListener('touchstart', function (event) {
          if (!event.touches.length) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        }, { passive: true });

        galleryStage.addEventListener('touchend', function (event) {
          var touch = event.changedTouches[0];
          var deltaX = touch.clientX - touchStartX;
          var deltaY = touch.clientY - touchStartY;
          if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY)) return;
          if (deltaX < 0) stepMedia(1);
          else stepMedia(-1);
        }, { passive: true });
      }

      goToMediaIndex(0);

      function selectedOptions() {
        return Array.from(section.querySelectorAll('.pw-product-options__input:checked')).map(function (input) {
          return input.value;
        });
      }

      function findVariant() {
        var selected = selectedOptions();
        if (!selected.length) return variants[0];

        return variants.find(function (variant) {
          return variant.options.every(function (option, index) {
            return option === selected[index];
          });
        });
      }

      function stockMessage(variant) {
        if (!variant.available) return soldOutText;
        return inStockText;
      }

      function setDynamicCheckoutState(available) {
        if (!dynamicCheckout) return;

        dynamicCheckout.classList.toggle('is-disabled', !available);
        dynamicCheckout.querySelectorAll(
          '.shopify-payment-button__button, .shopify-payment-button button, [data-shopify="payment-button"]'
        ).forEach(function (button) {
          button.style.pointerEvents = available ? '' : 'none';
          button.setAttribute('aria-disabled', available ? 'false' : 'true');

          if (button.tagName === 'BUTTON') {
            button.disabled = !available;
          }
        });
      }

      function updateVariant(variant) {
        if (!variant) return;

        if (variantInput) variantInput.value = variant.id;
        if (priceEl) priceEl.textContent = variant.price_formatted;

        if (compareEl) {
          var onSale = Number(variant.compare_at_price) > Number(variant.price);
          compareEl.textContent = onSale ? variant.compare_at_price_formatted : '';
          compareEl.classList.toggle('is-hidden', !onSale);
        }

        if (skuEl) skuEl.textContent = variant.sku || '';
        if (skuRow) skuRow.classList.toggle('is-hidden', !variant.sku);
        if (stockText) stockText.textContent = stockMessage(variant);
        if (stockStatus) stockStatus.classList.toggle('is-unavailable', !variant.available);

        if (addButton) addButton.disabled = !variant.available;
        setDynamicCheckoutState(variant.available);
        if (addLabel) addLabel.textContent = variant.available ? addText : soldOutText;

        if (variant.featured_media_id) switchMedia(variant.featured_media_id);
      }

      section.querySelectorAll('.pw-product-options__input').forEach(function (input) {
        input.addEventListener('change', function () {
          updateVariant(findVariant());
        });
      });

      section.querySelector('[data-quantity-minus]')?.addEventListener('click', function () {
        if (!quantityInput) return;
        var nextValue = Math.max(1, parseInt(quantityInput.value || '1', 10) - 1);
        quantityInput.value = nextValue;
      });

      section.querySelector('[data-quantity-plus]')?.addEventListener('click', function () {
        if (!quantityInput) return;
        quantityInput.value = parseInt(quantityInput.value || '1', 10) + 1;
      });

      if (dynamicCheckout) {
        var dynamicButtonsObserver = new MutationObserver(function () {
          setDynamicCheckoutState(!stockStatus?.classList.contains('is-unavailable'));
        });
        dynamicButtonsObserver.observe(dynamicCheckout, { childList: true, subtree: true });
        setDynamicCheckoutState(!stockStatus?.classList.contains('is-unavailable'));
      }

      section.querySelector('[data-wishlist-trigger]')?.addEventListener('click', function (event) {
        var button = event.currentTarget;
        if (!window.PawshelfWishlist) return;

        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');

        window.PawshelfWishlist.add({
          handle: button.dataset.handle,
          title: button.dataset.title,
          price: button.dataset.price,
          image: button.dataset.image,
          url: button.dataset.url
        });

        window.setTimeout(function () {
          button.classList.remove('is-loading');
          button.setAttribute('aria-busy', 'false');

          if (typeof window.openWishlist === 'function') {
            window.openWishlist();
          }
        }, 350);
      });

      section.querySelector('[data-share-product]')?.addEventListener('click', function () {
        var shareData = {
          title: document.title,
          url: window.location.href
        };

        if (navigator.share) {
          navigator.share(shareData).catch(function () {});
          return;
        }

        if (navigator.clipboard) {
          navigator.clipboard.writeText(window.location.href);
        }
      });
    }

    function boot() {
      document.querySelectorAll('.pw-product').forEach(initProduct);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var storageKey = 'Pawshelf_recently_viewed';

    function bindTouchSwipe(viewport, onSwipeLeft, onSwipeRight) {
      var startX = 0;
      var startY = 0;

      viewport.addEventListener('touchstart', function (event) {
        if (!event.touches.length) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });

      viewport.addEventListener('touchend', function (event) {
        var touch = event.changedTouches[0];
        var deltaX = touch.clientX - startX;
        var deltaY = touch.clientY - startY;
        if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        if (deltaX < 0) onSwipeLeft();
        else onSwipeRight();
      }, { passive: true });
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    function getViewed() {
      try {
        return JSON.parse(localStorage.getItem(storageKey) || '[]');
      } catch (error) {
        return [];
      }
    }

    function saveCurrent(currentHandle) {
      if (!currentHandle) return;

      var viewed = getViewed().filter(function (handle) {
        return handle !== currentHandle;
      });

      viewed.unshift(currentHandle);
      localStorage.setItem(storageKey, JSON.stringify(viewed.slice(0, 12)));
    }

    function formatMoney(cents, moneyFormat) {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, moneyFormat);
      }

      return (cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD'
      });
    }

    function fetchProduct(handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (response) {
          if (!response.ok) throw new Error('Unable to load product');
          return response.json();
        })
        .catch(function () {
          return null;
        });
    }

    function productImage(product) {
      if (product.featured_image) return product.featured_image;
      if (product.images && product.images.length) return product.images[0];
      return '';
    }

function renderCard(product, cartAddUrl, moneyFormat) {
  var image = productImage(product);
  var firstVariant = product.variants && product.variants.length ? product.variants[0] : null;
  var compare = product.compare_at_price && product.compare_at_price > product.price;
  var compareMarkup = compare ? '<span class="pw-rv-card__compare">' + formatMoney(product.compare_at_price, moneyFormat) + '</span>' : '';
  var formMarkup = '';

  // Build responsive image using <picture>
  var imageMarkup = '';
  if (image) {
    var img134 = image.replace(/(\.[^.]+)$/, '_134x$1').replace(/\?.*$/, '');
    var img250 = image.replace(/(\.[^.]+)$/, '_250x$1').replace(/\?.*$/, '');

    imageMarkup =
      '<picture>' +
        '<source media="(max-width: 749px)" srcset="' + img134 + '">' +
        '<source media="(min-width: 750px)" srcset="' + img250 + '">' +
        '<img class="pw-rv-card__image" src="' + img250 + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="250" height="250">' +
      '</picture>';
  }

  if (firstVariant && product.available) {
    formMarkup =
      '<form method="post" action="' + cartAddUrl + '" class="pw-rv-card__form">' +
        '<input type="hidden" name="id" value="' + firstVariant.id + '">' +
        '<button type="submit" class="pw-rv-card__button ajax-add-to-cart">' +
          '<span class="btn-text">Add to cart</span>' +
          '<span class="loader" aria-hidden="true"></span>' +
        '</button>' +
      '</form>';
  } else {
    formMarkup = '<button class="pw-rv-card__button" type="button" disabled>Sold out</button>';
  }

  return (
    '<div class="pw-recently-viewed__slide">' +
      '<article class="pw-rv-card">' +
        '<a class="pw-rv-card__media" href="' + product.url + '" aria-label="' + escapeHtml(product.title) + '">' +
          imageMarkup +
        '</a>' +
        '<a class="pw-rv-card__title" href="' + product.url + '">' + escapeHtml(product.title) + '</a>' +
        '<div class="pw-rv-card__price">' +
          compareMarkup +
          '<span class="pw-rv-card__current">' + formatMoney(product.price, moneyFormat) + '</span>' +
        '</div>' +
        formMarkup +
      '</article>' +
    '</div>'
  );
}

    function initSlider(section) {
      var viewport = section.querySelector('[data-slider-viewport]');
      var track = section.querySelector('[data-slider-track]');
      var prev = section.querySelector('[data-slider-prev]');
      var next = section.querySelector('[data-slider-next]');
      if (!viewport || !track) return;

      var index = 0;
      var gap = 18;

      function visibleCount() {
        var width = window.innerWidth;
        if (width <= 640) return parseFloat(section.dataset.visibleMobile || '2');
        if (width <= 989) return parseFloat(section.dataset.visibleTablet || '6');
        if (width <= 1199) return parseFloat(section.dataset.visibleLaptop || '4');
        return parseFloat(section.dataset.visibleDesktop || '5');
      }

      function setGap() {
        gap = window.innerWidth <= 760 ? 14 : 18;
      }

      function slideWidth() {
        var visible = visibleCount();
        return (viewport.clientWidth - (Math.ceil(visible) - 1) * gap) / visible;
      }

      function maxIndex() {
        return Math.max(0, track.children.length - Math.floor(visibleCount()));
      }

      function sizeSlides() {
        var width = slideWidth();
        Array.from(track.children).forEach(function (slide) {
          slide.style.width = width + 'px';
        });
      }

      function goTo(nextIndex) {
        setGap();
        sizeSlides();
        index = Math.min(Math.max(nextIndex, 0), maxIndex());
        track.style.transform = 'translateX(-' + index * (slideWidth() + gap) + 'px)';

        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === maxIndex();
      }

      prev?.addEventListener('click', function () {
        goTo(index - 1);
      });

      next?.addEventListener('click', function () {
        goTo(index + 1);
      });

      window.addEventListener('resize', function () {
        goTo(index);
      });

      bindTouchSwipe(viewport, function () {
        goTo(index + 1);
      }, function () {
        goTo(index - 1);
      });

      goTo(0);
    }

    function initSection(section) {
      var track = section.querySelector('[data-recently-viewed-track]');
      if (!track) return;

      var currentHandle = section.dataset.currentHandle || '';
      var displayLimit = parseInt(section.dataset.displayLimit || '10', 10);
      var moneyFormat = section.dataset.moneyFormat || ('$' + '{' + '{amount}' + '}' + '}');
      var cartAddUrl = section.dataset.cartAddUrl || '/cart/add';

      var handles = getViewed()
        .filter(function (handle) {
          return handle !== currentHandle;
        })
        .slice(0, displayLimit);

      if (!handles.length) return;

      Promise.all(handles.map(fetchProduct)).then(function (products) {
        var availableProducts = products.filter(Boolean);
        if (!availableProducts.length) return;

        track.innerHTML = availableProducts.map(function (product) {
          return renderCard(product, cartAddUrl, moneyFormat);
        }).join('');

        section.hidden = false;
        initSlider(section);
      });
    }

    function boot() {
      document.querySelectorAll('[data-recently-viewed]').forEach(function (section) {
        saveCurrent(section.dataset.currentHandle || '');
        initSection(section);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bindTouchSwipe(viewport, onSwipeLeft, onSwipeRight) {
      var startX = 0;
      var startY = 0;

      viewport.addEventListener('touchstart', function (event) {
        if (!event.touches.length) return;
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });

      viewport.addEventListener('touchend', function (event) {
        var touch = event.changedTouches[0];
        var deltaX = touch.clientX - startX;
        var deltaY = touch.clientY - startY;
        if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        if (deltaX < 0) onSwipeLeft();
        else onSwipeRight();
      }, { passive: true });
    }

    function initSlider(section) {
      var viewport = section.querySelector('[data-slider-viewport]');
      var track = section.querySelector('[data-slider-track]');
      var prev = section.querySelector('[data-slider-prev]');
      var next = section.querySelector('[data-slider-next]');
      if (!viewport || !track) return;

      var index = 0;
      var gap = 18;

      function visibleCount() {
        var width = window.innerWidth;
        if (width <= 640) return parseFloat(section.dataset.visibleMobile || '2');
        if (width <= 989) return parseFloat(section.dataset.visibleTablet || '6');
        if (width <= 1199) return parseFloat(section.dataset.visibleLaptop || '4');
        return parseFloat(section.dataset.visibleDesktop || '5');
      }

      function setGap() {
        gap = window.innerWidth <= 760 ? 14 : 18;
      }

      function slideWidth() {
        var visible = visibleCount();
        return (viewport.clientWidth - (Math.ceil(visible) - 1) * gap) / visible;
      }

      function maxIndex() {
        return Math.max(0, track.children.length - Math.floor(visibleCount()));
      }

      function sizeSlides() {
        var width = slideWidth();
        Array.from(track.children).forEach(function (slide) {
          slide.style.width = width + 'px';
        });
      }

      function goTo(nextIndex) {
        setGap();
        sizeSlides();
        index = Math.min(Math.max(nextIndex, 0), maxIndex());
        track.style.transform = 'translateX(-' + index * (slideWidth() + gap) + 'px)';

        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === maxIndex();
      }

      prev?.addEventListener('click', function () {
        goTo(index - 1);
      });

      next?.addEventListener('click', function () {
        goTo(index + 1);
      });

      window.addEventListener('resize', function () {
        goTo(index);
      });

      bindTouchSwipe(viewport, function () {
        goTo(index + 1);
      }, function () {
        goTo(index - 1);
      });

      goTo(0);
    }

    function loadRecommendations(section) {
      if (!section || !section.dataset.url) return;
      if (section.dataset.loaded === 'true') {
        initSlider(section);
        return;
      }

      fetch(section.dataset.url)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          var updated = html.getElementById(section.id);

          if (updated) {
            section.innerHTML = updated.innerHTML;
            section.dataset.loaded = 'true';
            initSlider(section);
          }
        })
        .catch(function () {
          var loading = section.querySelector('.pw-related-products__loading');
          if (loading) loading.textContent = '';
        });
    }

    function boot() {
      document.querySelectorAll('[data-product-recommendations]').forEach(loadRecommendations);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (function() {
    const ProductsGrid = document.getElementById('ProductsGrid');
    const LoadMoreBtn = document.getElementById('LoadMoreBtn');
    const ShowLessBtn = document.getElementById('ShowLessBtn');
    const FilterMobileBtn = document.getElementById('FilterMobileBtn');
    const SidebarClose = document.getElementById('SidebarClose');
    const CollectionSidebar = document.getElementById('CollectionSidebar');
    const ClearFilters = document.getElementById('ClearFilters');
    const SortBy = document.getElementById('SortBy');

    if (!ProductsGrid) return;

    let allProducts = [];
    let displayedProducts = 12;
    const itemsPerLoad = 12;

    function init() {
      allProducts = Array.from(ProductsGrid.querySelectorAll('.product-card-wrapper')).map(el => ({
        id: el.dataset.productId,
        element: el,
        available: el.querySelector('.product-card__cart-btn')?.disabled !== true,
        vendor: el.querySelector('.product-card__title')?.textContent?.trim() || '',
        price: parseFloat(el.querySelector('.product-card__price')?.textContent?.replace(/[^0-9.]/g, '') || '0')
      }));

      allProducts.forEach((p, i) => {
        if (i >= displayedProducts) p.element.classList.add('is-hidden');
      });

      if (LoadMoreBtn) LoadMoreBtn.addEventListener('click', loadMore);
      if (ShowLessBtn) ShowLessBtn.addEventListener('click', showLess);
      if (FilterMobileBtn) FilterMobileBtn.addEventListener('click', openSidebar);
      if (SidebarClose) SidebarClose.addEventListener('click', closeSidebar);
      if (ClearFilters) ClearFilters.addEventListener('click', clearAllFilters);
      if (SortBy) SortBy.addEventListener('change', handleSort);

      document.querySelectorAll('.filter-header').forEach(btn => {
        btn.addEventListener('click', toggleFilterSection);
      });

      document.querySelectorAll('.filter-checkbox').forEach(checkbox => {
        checkbox.addEventListener('change', applyFilters);
      });

      document.querySelectorAll('[data-apply="price"]').forEach(btn => {
        btn.addEventListener('click', applyFilters);
      });

      updateButtonState();
    }

    function toggleFilterSection(e) {
      const filterName = e.currentTarget.dataset.filter;
      const content = document.querySelector(`[data-filter-name="${filterName}"]`);
      const header = e.currentTarget;
      if (content) {
        content.classList.toggle('active');
        header.classList.toggle('active');
      }
    }

    function applyFilters() {
      displayedProducts = 12;
      updateGrid();
    }

    function filterProducts(products) {
      const availability = Array.from(document.querySelectorAll('input[name="availability"]:checked')).map(cb => cb.value);
      const vendors = Array.from(document.querySelectorAll('input[name="vendor"]:checked')).map(cb => cb.value);
      const minPrice = parseFloat(document.getElementById('PriceMin')?.value) || 0;
      const maxPrice = parseFloat(document.getElementById('PriceMax')?.value) || Infinity;

      return products.filter(p => {
        const el = p.element;
        const isAvailable = el.dataset.available === 'true';
        const vendor = el.dataset.vendor || '';
        const price = parseFloat(el.dataset.price || '0') / 100;

        if (availability.includes('in-stock') && !isAvailable) return false;
        if (availability.includes('out-of-stock') && isAvailable) return false;
        if (vendors.length && !vendors.includes(vendor)) return false;
        if (price < minPrice || price > maxPrice) return false;
        return true;
      });
    }

    function updateGrid() {
      const filtered = filterProducts(allProducts);
      allProducts.forEach(p => p.element.classList.add('is-hidden'));
      filtered.slice(0, displayedProducts).forEach(p => p.element.classList.remove('is-hidden'));
      updateButtonState(filtered.length);
    }

    function loadMore() {
      displayedProducts += itemsPerLoad;
      if (LoadMoreBtn) LoadMoreBtn.classList.add('loading');
      setTimeout(() => {
        updateGrid();
        if (LoadMoreBtn) LoadMoreBtn.classList.remove('loading');
        ProductsGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 300);
    }

    function showLess() {
      displayedProducts = 12;
      updateGrid();
      ProductsGrid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function updateButtonState(totalOverride) {
      const total = totalOverride ?? filterProducts(allProducts).length;
      if (LoadMoreBtn) {
        LoadMoreBtn.classList.toggle('hidden', displayedProducts >= total);
      }
      if (ShowLessBtn) {
        ShowLessBtn.classList.toggle('hidden', displayedProducts <= 12);
      }
    }

    function openSidebar() {
      CollectionSidebar?.classList.add('active');
      document.body.style.overflow = 'hidden';
    }

    function closeSidebar() {
      CollectionSidebar?.classList.remove('active');
      document.body.style.overflow = '';
    }

    function clearAllFilters() {
      document.querySelectorAll('.filter-checkbox:checked').forEach(cb => { cb.checked = false; });
      const priceMin = document.getElementById('PriceMin');
      const priceMax = document.getElementById('PriceMax');
      if (priceMin) priceMin.value = '';
      if (priceMax) priceMax.value = '';
      displayedProducts = 12;
      updateGrid();
    }

    function handleSort(e) {
      const sortValue = e.target.value;
      const grid = ProductsGrid;
      const items = Array.from(grid.querySelectorAll('.product-card-wrapper'));

      items.sort((a, b) => {
        const priceA = parseFloat(a.dataset.price || '0');
        const priceB = parseFloat(b.dataset.price || '0');
        if (sortValue === 'price-low') return priceA - priceB;
        if (sortValue === 'price-high') return priceB - priceA;
        return 0;
      });

      items.forEach(item => grid.appendChild(item));
      allProducts = items.map(el => ({ id: el.dataset.productId, element: el }));
      updateGrid();
    }

    init();
  })();

  } catch(e) { console.error(e); }
})();
})();
